Shopify = Shopify || {};

/*
Override so that Shopify.formatMoney returns pretty
money values instead of cents.
*/

Shopify.money_format = '${{amount}}';
Shopify.secure_url;
Shopify.permanent_domain;
Shopify.cartSubscription = false;
Shopify.discountCode;
Shopify.promotionConfig = {};
Shopify.runPromotions = function(){};
Shopify.getCookie = function(name) {
	return (document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2];
};

Shopify.onError = function(type, message) {
  // Shopify returns a JSON description of the error in XMLHttpRequest.responseText.
  // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
  var data = message;
  if (message) {
    console.log(type +': '+ data.message);
  } else {
    console.log('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
  }
};

let cartUpdating = false,
  loaderTimeout;
Shopify.loader = function(isLoading) {
  if (isLoading && cartUpdating) return;
  if (!isLoading && !cartUpdating) return;

  clearTimeout(loaderTimeout);

  if (isLoading) {
    cartUpdating = isLoading;
    return document.body.classList.add('cart-updating');
  }

  loaderTimeout = setTimeout(() => {
    cartUpdating = isLoading;
    return document.body.classList.remove('cart-updating');
  }, 300);
};

Shopify.fullMessagesFromErrors = function(errors) {
  var fullMessages = [];
  jQuery.each(errors, function(attribute, messages) {
    jQuery.each(messages, function(index, message) {
      fullMessages.push(attribute + ' ' + message);
    });
  });
  return fullMessages;
};

Shopify.showPromotionBar = function(cart) {
  const alert = document.querySelector('#sideCart .promo-alert');
  if (!alert) return;
  if (cart.item_count > 0) alert.classList.remove("d-none");
  else alert.classList.add("d-none");
  return true;
};

Shopify.updateCartElements = function(cart) {
  var cartPage_TotalItems = document.querySelectorAll('[cart-quantity]');
  var miniCart_TotalItems = document.querySelectorAll('[mini-cart-count]');
  var cart_OriginalTotalPrice = document.querySelector('[cart-original-total-price]');
  var cart_TotalPrice = document.querySelector('[cart-total-price]');
  var miniCart_buttonCheckout = document.querySelector('[mini-cart-btn-checkout]');
  var miniCart_buttonShop = document.querySelector('[mini-cart-btn-shop]');
  var miniCart_buttonCart = document.querySelector('[mini-cart-btn-cart]');
  var cart_noItems = document.getElementById('cartNoItems');
  var cart_hasItems = document.getElementById('cartHasItems');
  var item_count = cart.item_count;

  showCartLinks(item_count > 0);

  Shopify.cartSubscription = false;
  for (let i = 0; i < cart.items.length; i += 1) {
    if (cart.items[i].selling_plan_allocation) {
      Shopify.cartSubscription = true;
      break;
    }
  }

  if(cart_noItems) cart_noItems.style.display = (item_count == 0)?'block':'none';
  if(cart_hasItems) cart_hasItems.style.display = (item_count == 0)?'none':'block';

  if(cartPage_TotalItems) cartPage_TotalItems.forEach((ele) => { ele.innerHTML = item_count; });
  if(miniCart_TotalItems) miniCart_TotalItems.forEach((ele) => { ele.innerHTML = item_count; ele.classList.remove("d-none"); ele.style.display = (item_count > 0)?'inline-block':'none'; });

  if(miniCart_buttonShop) miniCart_buttonShop.style.display = (item_count > 0)?'none':'block';
  if(miniCart_buttonCheckout) miniCart_buttonCheckout.style.display = (item_count > 0)?'block':'none';
  
  if(cart_OriginalTotalPrice) { cart_OriginalTotalPrice.innerHTML = Shopify.formatMoney( cart.original_total_price ); }
  if(cart_TotalPrice) { cart_TotalPrice.innerHTML = Shopify.formatMoney( cart.total_price ); }
  if(miniCart_buttonCart) miniCart_buttonCart.style.display = (item_count > 0)?'block':'none';
  
  Shopify.loader(false);
}

Shopify.updateCartElement = function(item) {
  let item_ele = document.querySelectorAll('.order-list li[data-key="'+item.key+'"]')[0];
  item_ele.querySelector('.input-quantity input[quantity-select]').value = item.quantity;
  item_ele.querySelector('.input-quantity .input-group input').value = item.quantity;
}

Shopify.onCartUpdate = function(cart) {
  if(!cart) {
    Shopify.getCart(function(data){ 
      Shopify.showPromotionBar(data);
      Shopify.updateCartElements(data);
    });
  } else {
    Shopify.showPromotionBar(cart);
    Shopify.updateCartElements(cart);
  };
  Shopify.loader(false);
  Shopify.runPromotions();
};

Shopify.onCartShippingRatesUpdate = function(rates, shipping_address) {
  var readable_address = '';
  if (shipping_address.zip) readable_address += shipping_address.zip + ', ';
  if (shipping_address.province) readable_address += shipping_address.province + ', ';
  readable_address += shipping_address.country
  //alert('There are ' + rates.length + ' shipping rates available for ' + readable_address +', starting at '+ Shopify.formatMoney(rates[0].price) +'.');
};

Shopify.getCartItems = function(callback) {
  fetch('/cart?view=items')
    .then(response => response.text())
    .then((data) => {
      if (callback) callback(data);
    });
};

Shopify.onItemAdded = function(item) {
  const cartBody = document.querySelector('[js-cart-body]');
  if (!cartBody) return;

  Shopify.getCartItems((html) => {
    cartBody.innerHTML = html;
    bindCartEvents();
  });
  
  Shopify.onCartUpdate();
};

// ---------------------------------------------------------
// GET cart.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.getCart = function(callback) {
  fetch('/cart.js')
  .then(response => response.json())
  .then(data => { 
    if ((typeof callback) === 'function') {
      callback(data);
    } else {
     return data; 
    }
  });
};

/* Tools */

/*
Examples of call:
Shopify.formatMoney(600000, 'â‚¬{{amount_with_comma_separator}} EUR')
Shopify.formatMoney(600000, 'â‚¬{{amount}} EUR')
Shopify.formatMoney(600000, '${{amount_no_decimals}}')
Shopify.formatMoney(600000, '{{ shop.money_format }}') in a Liquid template!

In a Liquid template, you have access to a shop money formats with:
{{ shop.money_format }}
{{ shop.money_with_currency_format }}
{{ shop.money_without_currency_format }}
All these formats are editable on the Preferences page in your admin.
*/
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

Shopify.resizeImage = function(image, size) {
  try {
    if(size == 'original') { return image; }
    else {
      var matches = image.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
      return image+'&width='+size;
    }
  } catch (e) { return image; }
};

/* Ajax API */

// -------------------------------------------------------------------------------------
// POST to cart/add.js returns the JSON of the line item associated with the added item.
// -------------------------------------------------------------------------------------
Shopify.addItem = function(variant_id, quantity, callback) {
  var quantity = quantity || 1;
  let formData = { 'items': [{ 'id': variant_id, 'quantity': quantity }] };
  let item = false;
  
  Shopify.loader(true);
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    data['items'].forEach((item) => {
      Shopify.onItemAdded(item);
    });

    if ((typeof callback) === 'function') {
      callback(item);
    }
  })
  .catch((error) => {
    Shopify.onError('Error:', error);
  });

};

Shopify.addItemFromData = function(formData, callback) {
  let item = false;
  
  Shopify.loader(true);
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    data['items'].forEach((item) => { 
      Shopify.onItemAdded(item);
    });
    
    if ((typeof callback) === 'function') {
      callback(item);
    }
  })
  .catch((error) => {
    Shopify.onError('Error:', error);
  });

};

// ---------------------------------------------------------
// POST to cart/add.js returns the JSON of the line item.
// ---------------------------------------------------------
Shopify.addItemFromForm = function(form_id, callback) {
  let form = document.getElementById(form_id);
  let formData = new FormData(form);
  let item = false;

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    Shopify.onItemAdded(data);

    Shopify.getCart();
    
    if ((typeof callback) === 'function') {
      callback(data);
    }
  })
  .catch((error) => {
    console.log('-- add error');
    Shopify.onError('Error:', error);
  });
};

Shopify.pollForCartShippingRatesForDestination = function(shippingAddress, callback, errback) {
  errback = errback || Shopify.onError;
  var poller = function() {
    jQuery.ajax('/cart/async_shipping_rates', {
      dataType: 'json',
      success: function(response, textStatus, xhr) {
        if (xhr.status === 200) {
          if ((typeof callback) == 'function') {
            callback(response.shipping_rates, shippingAddress)
          } else {
            Shopify.onCartShippingRatesUpdate(response.shipping_rates, shippingAddress)
          }
        } else {
          setTimeout(poller, 500)
        }
      },
      error: errback
    })
  }

  return poller;
}

Shopify.getCartShippingRatesForDestination = function(shippingAddress, callback, errback) {
  errback = errback || Shopify.onError;
  var params = {
    type: 'POST',
    url: '/cart/prepare_shipping_rates',
    data: Shopify.param({'shipping_address': shippingAddress}),
    success: Shopify.pollForCartShippingRatesForDestination(shippingAddress, callback, errback),
    error: errback
  }

  jQuery.ajax(params);
}

// ---------------------------------------------------------
// GET products/<product-handle>.js returns the product in JSON.
// ---------------------------------------------------------
Shopify.getProduct = function(handle, callback) {
  fetch('/products/' + handle + '.js')
  .then(response => response.json())
  .then(data => { 
    if ((typeof callback) === 'function') {
      callback(data);
    }
  });
};

// ---------------------------------------------------------
// POST to cart/change.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.changeItem = function(key, quantity, callback) {
  const removeEl = document.querySelector(`[data-js-remove="${ key }"]`);
  const el = removeEl && quantity === 0 ? removeEl.closest('.cart-item') : false;
  if (removeEl && parseInt(removeEl.dataset.lastQty) === quantity) return;
  if (removeEl) removeEl.dataset.lastQty = quantity;

  const formData = {id: `${ key }`, quantity: quantity > 3 ? 3 : quantity };
  
  Shopify.loader(true);
  
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    if(el) el.remove();
    Shopify.onCartUpdate(data);
    if (typeof callback === 'function') callback(data);
  }).catch((error) => Shopify.onError('Error:', error));
};

// ---------------------------------------------------------
// POST to cart/change.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.removeItem = (key, callback) => Shopify.changeItem(key, 0, callback);

if (jQuery.fn.jquery >= '1.4') {
  Shopify.param = jQuery.param;
} else {
  Shopify.param = function( a ) {
    var s = [],
      add = function( key, value ) {
        // If value is a function, invoke it and return its value
        value = jQuery.isFunction(value) ? value() : value;
        s[ s.length ] = encodeURIComponent(key) + "=" + encodeURIComponent(value);
      };

    // If an array was passed in, assume that it is an array of form elements.
    if ( jQuery.isArray(a) || a.jquery ) {
      // Serialize the form elements
      jQuery.each( a, function() {
        add( this.name, this.value );
      });

    } else {
      for ( var prefix in a ) {
        Shopify.buildParams( prefix, a[prefix], add );
      }
    }

    // Return the resulting serialization
    return s.join("&").replace(/%20/g, "+");
  }

  Shopify.buildParams = function( prefix, obj, add ) {
    if ( jQuery.isArray(obj) && obj.length ) {
      // Serialize array item.
      jQuery.each( obj, function( i, v ) {
        if ( rbracket.test( prefix ) ) {
          // Treat each array item as a scalar.
          add( prefix, v );

        } else {
          Shopify.buildParams( prefix + "[" + ( typeof v === "object" || jQuery.isArray(v) ? i : "" ) + "]", v, add );
        }
      });

    } else if ( obj != null && typeof obj === "object" ) {
      if ( Shopify.isEmptyObject( obj ) ) {
        add( prefix, "" );

      // Serialize object item.
      } else {
        jQuery.each( obj, function( k, v ) {
          Shopify.buildParams( prefix + "[" + k + "]", v, add );
        });
      }

    } else {
      // Serialize scalar item.
      add( prefix, obj );
    }
  }

  Shopify.isEmptyObject = function( obj ) {
    for ( var name in obj ) return false;
    return true;
  }
}

/* Used by Tools */

function floatToString(numeric, decimals) {
  var amount = numeric.toFixed(decimals).toString();
  if(amount.match(/^\.\d+/)) {return "0"+amount; }
  else { return amount; }
}

/* Used by API */
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    // Converts to a string.
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  // Removing leading and trailing whitespace.
  return jQuery.trim(attribute);
}

function bindCartEvents () {
  jQuery('[data-js-remove]').on('click', function (evt) {
    const key = jQuery(this).data('js-remove');
    Shopify.removeItem(key);
  });

  jQuery('.cart-item [quantity-select]').each(function(index) {
    if(jQuery(this).next().length == 0) jQuery(this).inputSpinner();
    jQuery(this).on("change", function (event) {
      var quantityEle = jQuery(this).closest('[quantity-select]');
      var item_key = quantityEle.data('key');
      var item_price = quantityEle.data('variant-price');
      var item_original_price = quantityEle.data('variant-original-price');
      var qty = parseInt(jQuery(this).val());
      var parent_ele =jQuery(this).parent().parent().parent();

      /* if at 3, show a warning: */
      if(qty >= 3) {
        jQuery('#cartMaxQuantityModal').modal('toggle');
        
        if (qty > 3) { /* if > 3, stop: */
          jQuery(quantityEle).val(3);
          Shopify.changeItem(item_key, 3);
          return;
        }
      }

      Shopify.changeItem(item_key, qty, function() {
        /* update line item price */
        parent_ele.find('[item-price]').html( Shopify.formatMoney((item_price*qty)));
        if( item_original_price > item_price)
          parent_ele.find('[item-original-price]').html( Shopify.formatMoney( (item_original_price*qty) ));
      });

    });
  });
}

/* swap open cart with product shop button: */
function showCartLinks (hasItems = false) {
  const showIfItems = document.querySelector('[data-show-cart]');
  const hideIfItems = document.querySelector('[data-hide-cart]');

  if (hasItems) {
    if (showIfItems) showIfItems.hidden = false;
    if (hideIfItems) hideIfItems.hidden = true;
  } else {
    if (showIfItems) showIfItems.hidden = true;
    if (hideIfItems) hideIfItems.hidden = false;
  }
}

var wait = 0;
function onLoad () {
  /* make sure bootstrap is loaded: */
  if (!window.bootstrap) {
    if (wait > 20) return;
    setTimeout(() => {
      wait += 1;
      onLoad();
    }, 100);
    return;
  }

  var sideCartEle = document.getElementById('sideCart');
  var sideCart = new window.bootstrap.Offcanvas(sideCartEle);

  if ((typeof Shopify) === 'undefined') { Shopify = {}; }

  Shopify.showCart = function(show = true) {
    if(show && sideCartEle.classList.contains('show')) return;
    sideCart.toggle();
  };

  sideCartEle.addEventListener('show.bs.offcanvas', function () {
    dataLayer.push({ 'event': 'cart_view' });
  });

  let actionsBound = false;
  Shopify.bindCartActions = function() {
    if (actionsBound) return;
    actionsBound = true;
    /* Click Add-to-Cart on item */
    jQuery('[add-to-cart]').on('click', function (evt) {
      const $form = jQuery(this).closest('form');
      if (!$form) return;

      evt.preventDefault();
      const variant_id = jQuery('[name="id"]', $form).val();
      const selling_plan_id = jQuery('[name="selling_plan"]', $form).val();

      const formData = {
        'items': [{ 
          'id': variant_id, 
          'quantity': 1,
          'selling_plan': selling_plan_id
        }] 
      };

      Shopify.addItemFromData(formData, function(item) {
        if( window.location.pathname == '/cart' ) {
          window.location.href = window.location.pathname;
        } else {
          jQuery("li[data-key="+item.key+"]").hide();
          Shopify.runPromotions();
          Shopify.showCart(true);
        }
      });
    });

    bindCartEvents();
  };

  Shopify.runPromotions();
  Shopify.bindCartActions();
};

window.addEventListener('DOMContentLoaded', onLoad);